export enum AppAuthorizationState {
    GoToLogin = 'GoToLogin',
    Loading = 'Loading',
    Allowed = 'Allowed',
    Anonymous = 'Anonymous',
    Denied = 'Denied',
    Pending = 'Pending'
}
